import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import DealerService from '../../../service/DealerService';
import secureStorage from './../../../config/encrypt';
import DateFormate from 'dateformat';
import { ADMIN_ALLOWED_FOR_OTP_LOOKUP } from '../../../config/constant';

const OtpLookup = (props) => {
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(false);
    const [otpData, setOtpData] = useState(null);
    const [redirect, setRedirect] = useState(null);

    useEffect(() => {
        const loginResponse = secureStorage.getItem('loginUserInfo');

        if (!loginResponse) {
            setRedirect('/login');
            return;
        }

        props.updateStateIntoRedux('LOGIN_USER', loginResponse);
        const user_id = loginResponse?.data?.user_data?.user_id;

        // ALLOW-LIST CHECK
        if (!ADMIN_ALLOWED_FOR_OTP_LOOKUP.includes(user_id)) {
            toast.error("You are not authorized to access OTP Lookup");
            setRedirect('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!mobile.trim()) {
            toast.error("Mobile number is required");
            return;
        }

        try {
            setLoading(true);
            setOtpData(null);

            const response = await DealerService.getOtpDetails({ mobile });

            console.log('response ===========>', response);
            if (response?.data?.status === 200 && response.data.data) {
                setOtpData(response.data.data);
            } else if (response && response?.data && response?.data?.status === 403) {
                toast.error(response?.data?.message);
            } else {
                toast.warning("No OTP found for this mobile number");
            }

        } catch (error) {
            console.error(error);
            toast.error("Error fetching OTP details");
        } finally {
            setLoading(false);
        }
    };

    if (redirect) {
        return <Redirect to={redirect} />;
    }

    return (
        <div className="container-fluid">
            <h2 className="mb-3">OTP Lookup</h2>

            <div className="card p-3 mb-4">
                <form onSubmit={handleSubmit} className="form-inline" style={{ padding: "40px" }}>
                    <div className="form-group mr-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter mobile number"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                    </div>

                    <button className="btn btn-primary" type="submit" disabled={loading}>
                        Search
                    </button>

                    <button
                        type="button"
                        className="btn btn-secondary"
                        style={{ marginLeft: "5px" }}
                        onClick={() => {
                            setMobile('');
                            setOtpData(null);
                        }}
                    >
                        Clear
                    </button>
                </form>
            </div>

            {/* TABLE OUTPUT */}
            {otpData && (
                <div className="card">
                    <div className="card-body">
                        <h5>OTP Details</h5>
                        <table className="table table-bordered mt-3">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>User ID</th>
                                    <th>Mobile</th>
                                    <th>OTP</th>
                                    <th>Expiry Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{otpData.id}</td>
                                    <td>{otpData.user_id}</td>
                                    <td>{otpData.mobile}</td>
                                    <td>{otpData.otp}</td>
                                    <td>{otpData.expiry_time ? DateFormate(otpData.expiry_time, 'yyyy-mm-dd hh:MM TT') : '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

        </div>
    );
};

const mapStateToProps = state => ({
    auth_token: state.authToken,
    user_loggedin: state.userLoggedIn,
    dealer_id: state.dealer_id
});

const mapDispatchToProps = dispatch => ({
    updateStateIntoRedux: (actionType, stateData) =>
        dispatch({ type: actionType, componentState: stateData })
});

export default connect(mapStateToProps, mapDispatchToProps)(OtpLookup);
